export default __webpack_public_path__ + "static/media/linkedin.2e20afc9.svg";